import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { fetchCollection, fetchEntryBySlug } from '../lib/cms';
import Lightbox from '../components/Lightbox';

// Fallback nyheder hvis CMS fejler eller er tomt
const fallbackNews = [
  {
    id: 'd9cc176c-b844-4e6f-bbd6-9a7973dea7bc',
    slug: 'skt-byg-har-opdateret-sit-coverbillede',
    title: { da: 'SKT Byg har opdateret sit coverbillede' },
    date: '4 år siden',
    content: {
      da: '<p>SKT Byg har opdateret sit coverbillede.</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/468782425261320-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '4a74c0de-7e36-49eb-83d0-19ab992f811f',
    slug: 'skt-byg-fejrer-10-aars-jubilaeum',
    title: { da: 'SKT-byg fejrer 10 års jubilæum!' },
    date: '9 år siden',
    content: {
      da: '<p>Jeg har nu haft SKT-byg i 10 år. Derfor vil jeg gerne invitere til åbent hus lørdag den 13. Maj kl. 12-15 på Dronninghøj 1 i Storring.</p><p>Der vil være pølsevogn, fadøl og kaffe. Alle fra lokalområdet, kunder og samarbejdsparter er velkomne. Jeg håber du har lyst til at kigge forbi!</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1868669673401949-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '40d858e9-787a-46e2-bc9a-1809ee0342dc',
    slug: 'certificeret-i-firestone-rubbercover',
    title: { da: 'Certificeret i Firestone RubberCover' },
    date: '10 år siden',
    content: {
      da: '<p>Så er Christian, Kasper og jeg vendt hjem fra en hyggelig tur til Bruxelles. Her er vi blevet certificeret i at lægge et spændende tagprodukt, Firestone RubberCover, som er et alternativ til tagpap. Vi undgår brug af åben ild, og holdbarheden er rigtig god.</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1820354611566789-0-700.jpg',
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1820354611566789-1-700.jpg',
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1820354611566789-2-700.jpg',
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1820354611566789-3-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '60e0a3c0-77f2-4b33-bf85-68ab5af4f4fc',
    slug: 'nye-skabe-i-stjaer-vaabenhus',
    title: { da: 'Nye skabe i Stjær våbenhus' },
    date: '10 år siden',
    content: {
      da: '<p>Så blev vi færdig med opsætning af nye skabe i Stjær våbenhus.</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1735445666724351-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '59013e71-ec56-4873-b471-a338e6d6ed7e',
    slug: 'glaedelig-jul-og-godt-nytaar',
    title: { da: 'Glædelig jul og godt nytår!' },
    date: '11 år siden',
    content: {
      da: '<p>Vi ønsker alle en glædelig jul og et godt nytår! Vi glæder os til nye spændende projekter i det nye år!</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1648397538762498-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '48e1c7d8-6522-41f3-b485-7251f93a8cb4',
    slug: 'vinder-af-konkurrence-udtrukket',
    title: { da: 'Vinder af konkurrence udtrukket!' },
    date: '11 år siden',
    content: {
      da: '<p>Så er den heldige vinder i vores konkurrence om at vinde en tømrer for en dag, udtrukket! 🎉🎉 Tillykke til René Elfrom, der nu kan se frem til at få besøg af os i en hel dag. René vil blive kontaktet pr. mail, med yderligere oplysninger. Tak til alle der har deltaget. God dag!</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1626779787590940-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  },
  {
    id: '94524743-c695-486d-a72d-4d2c8c04f2e6',
    slug: 'vind-skt-byg-for-en-dag',
    title: { da: 'Vind SKT-Byg for en dag!' },
    date: '11 år siden',
    content: {
      da: '<p>Går du med drømmen om at starte et projekt? Nu har du muligheden for at skubbe projektet godt fra start, ved at vinde SKT-Byg for en dag! Deltag lige her på siden.</p>'
    },
    images: [
      'https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-842116020185094-0-700.jpg'
    ],
    facebookUrl: 'https://www.facebook.com/sktbyg/?ref=embed_page#'
  }
];

// Oprindelig rækkefølge for de historiske opslag (nyeste historiske øverst).
// Eventuelle nye opslag oprettet af kunden i CMS'et får automatisk prioritet 0 og lægger sig øverst!
const knownOrder = {
  'skt-byg-har-opdateret-sit-coverbillede': 1,
  'skt-byg-fejrer-10-aars-jubilaeum': 2,
  'certificeret-i-firestone-rubbercover': 3,
  'nye-skabe-i-stjaer-vaabenhus': 4,
  'glaedelig-jul-og-godt-nytaar': 5,
  'vinder-af-konkurrence-udtrukket': 6,
  'vind-skt-byg-for-en-dag': 7
};

export default function Nyheder() {
  const [pageData, setPageData] = useState(null);
  const [news, setNews] = useState(fallbackNews);
  const [loading, setLoading] = useState(true);

  // Tilstand for at aktivere officiel Facebook iframe (privatlivsvenlig click-to-load)
  const [loadFacebookPlugin, setLoadFacebookPlugin] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  useEffect(() => {
    async function loadNews() {
      try {
        const [page, cmsNews] = await Promise.all([
          fetchEntryBySlug('da', 'nyheder'),
          fetchCollection('news')
        ]);
        if (page) setPageData(page);

        // Hent 100% dynamisk fra CMS'et:
        // Kunden kan tilføje, redigere og slette opslag direkte i CMS'ets 'news'-samling!
        if (Array.isArray(cmsNews)) {
          const formatted = cmsNews.map((item) => ({
            id: item.id,
            slug: item.slug?.da || item.slug || item.id,
            title: item.title,
            date: item.date || '',
            content: item.content,
            images: Array.isArray(item.images) ? item.images : (item.images ? [item.images] : []),
            facebookUrl: item.facebookUrl || 'https://www.facebook.com/sktbyg/?ref=embed_page#',
            updatedAt: item.updatedAt
          }));

          // Sorter: Nye opslag (der ikke er i knownOrder) lægger sig automatisk øverst
          formatted.sort((a, b) => {
            const orderA = knownOrder[a.slug] ?? 0;
            const orderB = knownOrder[b.slug] ?? 0;
            if (orderA !== orderB) {
              return orderA - orderB;
            }
            return new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0);
          });

          setNews(formatted);
        }
      } catch (err) {
        console.error('Error loading news:', err);
      } finally {
        setLoading(false);
      }
    }
    loadNews();
  }, []);

  const handleOpenLightbox = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
    setIsLightboxOpen(true);
  };

  const handlePrevImage = () => {
    setLightboxIndex((prev) => (prev === 0 ? lightboxImages.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setLightboxIndex((prev) => (prev === lightboxImages.length - 1 ? 0 : prev + 1));
  };

  const metaTitle = pageData?.meta_title?.da || pageData?.meta_title || "Nyheder & Aktuelle Projekter | Følg SKT Byg";
  const metaDesc = pageData?.meta_description?.da || pageData?.meta_description || "Følg med i hverdagen hos SKT Byg. Se seneste opdateringer, nyheder og billeder fra vores aktuelle bygge- og renoveringsprojekter i Galten og omegn.";

  const pageTitle = pageData?.page_title?.da || pageData?.page_title || "Nyheder";
  const pageSubtitle = pageData?.page_subtitle?.da || pageData?.page_subtitle || "Følg med i seneste nyt fra vores Facebookside. Vi opdaterer løbende med billeder og historier fra vores hverdag og spændende projekter.";

  return (
    <div className="min-h-screen bg-brand-light py-12 md:py-16">
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDesc} />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/1594841080784811-1868669673401949-0-700.jpg" />
      </Helmet>

      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        {/* Sidetitel & Intro */}
        <div className="mb-10 max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-extrabold text-brand-dark mb-4">
            {pageTitle}
          </h1>
          <p className="text-base md:text-lg text-brand-dark/75 leading-relaxed">
            {pageSubtitle}
          </p>
        </div>

        {/* Facebook Side Integration & Få et godt tilbud (flyttet op over nyhedskortene) */}
        <div className="mb-14 border-b border-brand-sand pb-12 grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
          {/* Kort 1: Få et godt tilbud */}
          <div className="bg-brand-dark text-white p-8 flex flex-col justify-between shadow-xs">
            <div>
              <span className="text-xs font-bold uppercase tracking-widest text-brand-accent block mb-2">
                Uforpligtende pris
              </span>
              <h3 className="text-2xl font-extrabold mb-4">
                Få et godt tilbud
              </h3>
              <p className="text-sm text-white/75 leading-relaxed mb-6">
                Hvad end du tænker i stort eller småt, giver vi gerne en skarp og uforpligtende pris på dit projekt. Beskriv arbejdsopgaven for os i dag.
              </p>
            </div>
            <Link
              to="/faa-et-tilbud"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-brand-accent hover:bg-brand-accent-hover text-white text-xs font-bold uppercase tracking-wider transition-colors shadow-md w-full"
            >
              <span>Beskriv din opgave her</span>
              <span>»</span>
            </Link>
          </div>

          {/* Kort 2 & 3: Live Facebook Page Embed & Find os på Facebook */}
          <div className="lg:col-span-2 bg-white border border-brand-sand shadow-xs flex flex-col justify-between overflow-hidden">
            {/* Øvre sektion med introduktion og direkte knap */}
            <div className="p-6 sm:p-7 pb-4">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-5 border-b border-brand-sand">
                <div className="flex items-center gap-3.5">
                  <div className="h-11 w-11 bg-[#1877F2] text-white flex items-center justify-center text-xl shadow-xs shrink-0">
                    <i className="fa-brands fa-facebook-f"></i>
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-extrabold text-brand-dark leading-tight">
                      Find os på Facebook
                    </h3>
                    <p className="text-xs sm:text-sm text-brand-dark/65 mt-0.5">
                      Følg med i vores nyeste opgaver, hverdagsbilleder og opdateringer
                    </p>
                  </div>
                </div>

                <a
                  href="https://www.facebook.com/sktbyg/?ref=embed_page#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-[#1877F2] hover:bg-[#166fe5] text-white text-xs font-bold uppercase tracking-wider transition-colors shadow-xs shrink-0 self-start sm:self-auto"
                >
                  <i className="fa-brands fa-facebook text-sm"></i>
                  <span>Besøg Facebook-side</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px] opacity-80"></i>
                </a>
              </div>
            </div>

            {/* Selve visningsområdet (Facade eller aktiv widget) */}
            <div className="px-6 sm:px-7 pb-6 flex-1 flex flex-col justify-center">
              <div className="w-full bg-zinc-50 border border-brand-sand overflow-hidden">
                {!loadFacebookPlugin ? (
                  <div className="relative">
                    {/* Facebook Cover Billede */}
                    <div className="h-36 sm:h-44 w-full relative overflow-hidden bg-brand-dark">
                      <img
                        src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/468782425261320-0-700.jpg"
                        alt="SKT Byg Facebook Cover"
                        className="w-full h-full object-cover opacity-85"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/10" />
                      
                      {/* Badge øverst */}
                      <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-xs text-white text-[11px] font-semibold px-2.5 py-1 flex items-center gap-1.5 border border-white/10">
                        <i className="fa-brands fa-facebook text-[#1877F2]"></i>
                        <span>Officiel Facebook Page</span>
                      </div>
                    </div>

                    {/* Profil info bjælke & handlinger */}
                    <div className="p-5 sm:p-6 relative -mt-10 sm:-mt-12 flex flex-col md:flex-row md:items-end justify-between gap-5 bg-white border-t border-brand-sand/50">
                      <div className="flex items-end gap-4">
                        <div className="h-20 w-20 sm:h-22 sm:w-22 bg-brand-dark p-2.5 border-2 border-white shadow-lg shrink-0">
                          <img
                            src="https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/logo-hvid.png"
                            alt="SKT Byg"
                            className="h-full w-full object-contain"
                          />
                        </div>
                        <div className="mb-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-extrabold text-lg sm:text-xl text-brand-dark">SKT Byg</h4>
                            <span className="text-[#1877F2] text-sm" title="Verificeret side">
                              <i className="fa-solid fa-circle-check"></i>
                            </span>
                          </div>
                          <p className="text-xs sm:text-sm text-brand-dark/70 font-medium mt-0.5">
                            Tømrer & murer i Galten • 20 91 00 19
                          </p>
                          <p className="text-[11px] text-brand-dark/50 mt-0.5">
                            Lokal håndværker i Galten, Silkeborg, Aarhus & omegn
                          </p>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-2.5 pt-2 md:pt-0">
                        <button
                          onClick={() => setLoadFacebookPlugin(true)}
                          className="px-4 py-2 bg-white hover:bg-zinc-100 border border-brand-sand text-xs font-bold text-brand-dark transition-colors cursor-pointer flex items-center gap-2 shadow-xs"
                          title="Indlæs live Facebook iframe"
                        >
                          <i className="fa-solid fa-satellite-dish text-[#1877F2]"></i>
                          <span>Vis live feed</span>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="p-3 min-h-[380px] flex flex-col items-center justify-center bg-white">
                    <iframe
                      src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsktbyg%2F&tabs=timeline&width=500&height=380&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                      width="100%"
                      height="380"
                      style={{ border: 'none', overflow: 'hidden', minHeight: '380px' }}
                      scrolling="no"
                      frameBorder="0"
                      allowFullScreen={true}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                      title="SKT Byg Facebook Side Plugin"
                      className="w-full"
                    />
                    <div className="text-center pt-3 pb-1 border-t border-brand-sand/60 w-full mt-2">
                      <button
                        onClick={() => setLoadFacebookPlugin(false)}
                        className="inline-flex items-center gap-1.5 text-xs text-brand-dark/60 hover:text-brand-dark font-medium cursor-pointer"
                      >
                        <i className="fa-solid fa-xmark text-[11px]"></i>
                        <span>Luk live feed og vis overblik</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Bundlinje med direkte link */}
            <div className="px-6 sm:px-7 py-3.5 bg-zinc-50 border-t border-brand-sand flex flex-wrap items-center justify-between gap-3 text-xs text-brand-dark/70">
              <span className="flex items-center gap-2">
                <i className="fa-brands fa-facebook text-[#1877F2] text-sm"></i>
                <span>Direkte link: <strong className="text-brand-dark">facebook.com/sktbyg</strong></span>
              </span>
              <a
                href="https://www.facebook.com/sktbyg/?ref=embed_page#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1877F2] hover:text-[#166fe5] font-bold inline-flex items-center gap-1 hover:underline"
              >
                <span>Åbn på Facebook</span>
                <span>»</span>
              </a>
            </div>
          </div>
        </div>

        {/* 2 på række Nyhedskort */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
          {news.length === 0 && !loading && (
            <div className="col-span-full py-16 text-center bg-white border border-brand-sand p-8">
              <i className="fa-regular fa-newspaper text-4xl text-brand-dark/30 mb-4 block" aria-hidden="true"></i>
              <p className="text-brand-dark/70 text-lg font-medium">Der er i øjeblikket ingen nyheder at vise.</p>
              <p className="text-brand-dark/50 text-sm mt-1">Nye opslag oprettet i CMS'et vil automatisk blive vist her.</p>
            </div>
          )}

          {news.map((post) => {
            const titleText = typeof post.title === 'string' ? post.title : (post.title?.da || Object.values(post.title || {})[0] || '');
            const contentHtml = typeof post.content === 'string' ? post.content : (post.content?.da || Object.values(post.content || {})[0] || '');

            return (
              <article
                key={post.id}
                className="bg-white border border-brand-sand shadow-xs hover:shadow-md transition-shadow duration-300 flex flex-col justify-between overflow-hidden"
              >
                <div>
                  {/* Billeder med lightbox */}
                  {post.images && post.images.length > 0 && (
                    <div className="border-b border-brand-sand bg-zinc-100">
                      {post.images.length === 1 ? (
                        <div
                          onClick={() => handleOpenLightbox(post.images, 0)}
                          className="relative h-64 sm:h-72 w-full overflow-hidden cursor-pointer group"
                        >
                          <img
                            src={post.images[0]}
                            alt={titleText || "Nyhedsbillede"}
                            className="w-full h-full object-cover group-hover:scale-103 transition-transform duration-500"
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 flex items-center justify-center transition-all duration-300">
                            <div className="h-10 w-10 bg-brand-dark/90 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                              <i className="fa-solid fa-magnifying-glass-plus text-sm"></i>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="grid grid-cols-2 gap-1 p-1 bg-brand-sand/30">
                          {post.images.slice(0, 4).map((img, imgIdx) => (
                            <div
                              key={imgIdx}
                              onClick={() => handleOpenLightbox(post.images, imgIdx)}
                              className="relative h-36 sm:h-40 overflow-hidden cursor-pointer group bg-zinc-200"
                            >
                              <img
                                src={img}
                                alt={`${titleText || 'Nyhedsbillede'} ${imgIdx + 1}`}
                                className="w-full h-full object-cover group-hover:scale-103 transition-transform duration-500"
                                loading="lazy"
                              />
                              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 flex items-center justify-center transition-all duration-300">
                                <div className="h-8 w-8 bg-brand-dark/90 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-xs">
                                  <i className="fa-solid fa-magnifying-glass-plus"></i>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="p-6 sm:p-8">
                    {post.date && (
                      <div className="flex items-center gap-2 text-xs font-bold text-brand-accent uppercase tracking-wider mb-2">
                        <i className="fa-regular fa-calendar-days text-sm"></i>
                        <span>{post.date}</span>
                      </div>
                    )}

                    {titleText && (
                      <h2 className="text-xl sm:text-2xl font-extrabold text-brand-dark mb-4 leading-snug">
                        {titleText}
                      </h2>
                    )}

                    {contentHtml && (
                      <div
                        className="text-sm sm:text-base text-brand-dark/80 leading-relaxed prose prose-sm max-w-none"
                        dangerouslySetInnerHTML={{ __html: contentHtml }}
                      />
                    )}
                  </div>
                </div>

                <div className="px-6 sm:px-8 py-4 bg-zinc-50 border-t border-brand-sand flex items-center justify-between text-xs text-brand-dark/60 mt-auto">
                  <a
                    href={post.facebookUrl || "https://www.facebook.com/sktbyg/?ref=embed_page#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 font-bold text-brand-accent hover:text-brand-dark uppercase tracking-wider transition-colors"
                  >
                    <span>Vis på Facebook</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                  </a>
                  <span className="text-[11px] text-brand-dark/40 font-medium">SKT Byg</span>
                </div>
              </article>
            );
          })}
        </div>


      </div>

      {/* Lightbox til billeder */}
      {isLightboxOpen && (
        <Lightbox
          images={lightboxImages}
          currentIndex={lightboxIndex}
          onClose={() => setIsLightboxOpen(false)}
          onPrev={handlePrevImage}
          onNext={handleNextImage}
        />
      )}
    </div>
  );
}
